// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
/**
 * Formate et affiche les informations de mesure d'un produit
 * @param {Object} measurement - Objet de mesure du variant
 * @returns {string} - HTML formaté pour l'affichage
 */
function formatMeasurementDisplay(measurement) {
  if (!measurement) {
    return '';
  }

  const { measured_type, quantity_value, quantity_unit } = measurement;
  
  // Vérifier si le type de mesure est supporté
  if (!['weight', 'volume'].includes(measured_type)) {
    return '';
  }

  const roundedValue = Math.floor(quantity_value); // cache les décimales
  return `${roundedValue} ${quantity_unit}`;
}

/**
 * Met à jour l'affichage du poids/volume net du variant
 * @param {Object} variant - Objet variant du produit
 */
function updateVariantNetSize(variant) {
  const container = document.getElementById("variant-net-size");
  
  if (!container) {
    console.warn("Container 'variant-net-size' introuvable");
    return;
  }

  if (!variant) {
    container.innerHTML = '';
    return;
  }

  const displayContent = formatMeasurementDisplay(variant.unit_price_measurement);
  container.innerHTML = displayContent;
}

document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  updateVariantNetSize(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});
